import { useGetDrawDownRepaymentScheduleIwocapay } from '../../../api/lending/lapiHooks';

export function useTotalInterest() {
  const { drawDownRepaymentScheduleIwocapay } =
    useGetDrawDownRepaymentScheduleIwocapay();

  return drawDownRepaymentScheduleIwocapay?.summary.total_interest ?? null;
}
